import router from '@/router'
import axios from '../../axios'
export default {
    namespaced: true,
    state: {},
    
    mutations: {
        SET_BEARER(state, token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token.access}`
            localStorage.setItem('access', token.access)
            localStorage.setItem('refresh', token.refresh)
        },
        remove() {
            localStorage.removeItem('refresh')
            localStorage.removeItem('access')
        }
    },
    actions: {
        emailJWT({ commit }, payload) {
            return new Promise((resolve, reject) => {
              axios.defaults.headers.common['Authorization'] = ''
                axios.post('/company/register/', {
                    email: payload.userDetails.email,
                    password: payload.userDetails.password
                })
                    .then(response => {
                        if (response.data.data.status == 'activation code is sent') {
                            resolve(response)
                        } else {
                            reject(response.data)
                        }
                    })
                    .catch(error => { reject(error) })
            })
            //  })
        },
        loginJWT({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios.post('token/', payload)
                    .then(response => {
                        // console.log(response.data);
                        // If there's user data in response
                        if (response.data) {
                            // Set bearer token
                            commit('SET_BEARER', response.data)
                            // Navigate User to homepage
                            router.push(router.currentRoute.query.to || '/')
                            resolve(response)
                        } else {
                            reject({ message: 'Wrong Email or Password' })
                        }
                    })
                    .catch(error => { reject(error) })
            })
        },
        registerUserJWT(_, payload) {
            // console.log(payload.userDetails)
            return new Promise((resolve, reject) => {
                axios.post(
                    '/validate_activation_code/',
                    payload
                )
                    .then(response => {
                        if (response.status === 200) {
                            router.push(router.currentRoute.query.to || '/login')
                        } else {
                            reject({ message: 'Wrong code, try again' })
                        }
                    })
                    .catch(error => { reject(error) })
            })
        },
        LogOut() {
            localStorage.removeItem('access')
            localStorage.removeItem('refresh')
        },
    },
    getters: {}
}
